import { useDispatch } from "react-redux";
import { action } from "../../../store/action";

export const useStateCleaner = () => {
  const dispatch = useDispatch();

  const clearStateAllProducts = () => {
    dispatch(action.saveProductCategory(undefined));
    dispatch(action.clearCart());
    dispatch(action.clearCartSelections());
  };

  const clearStateForProductCategory = () => {
    dispatch(action.saveCartSelectionsProductTiltrotator(undefined));
    clearStateForProductCategoryTiltrotator();
    clearStateForProductCategoryMachineFixings();
    clearStateForOptionalStep();
  };

  const clearStateForProductCategoryTiltrotator = () => {
    dispatch(action.saveProductMachineFixingType(undefined));
    clearStateForProductMachineFixingType();
  };

  const clearStateForProductMachineFixingType = () => {
    dispatch(action.saveCartSelectionsProductMachineFixing(undefined));
    dispatch(action.saveCartSelectionsProductUpperBracket(undefined));
    dispatch(action.saveCartSelectionsProductLowerBracket(undefined));
    dispatch(action.saveCartSelectionsProductGrappleModule(undefined));
    dispatch(action.saveCartSelectionsProductNoGrappleModuleSelected(false));
  };

  const clearStateForOptionalTools = () => {
    dispatch(action.saveOptionalToolsIsToolsSelected(false));
    dispatch(action.saveOptionalToolsProductTypes([]));
    dispatch(action.saveCartSelectionsOptionalToolsProductItems([]));
    dispatch(action.saveCartOptionalToolsProductItems([]));
  };

  const clearStateForProductCategoryMachineFixings = () => {
    dispatch(action.saveProductToolsProductTypes([]));
    dispatch(action.saveCartSelectionsProductToolsProductItems([]));
    clearStateForProductCategoryTiltrotator();
  };

  const clearStateForOptionalStep = () => {
    dispatch(action.saveOptionalToolsIsToolsSelected(false));
    dispatch(action.saveOptionalToolsIsTiltrotatorsSelected(false));
    dispatch(action.saveOptionalToolsProductTypes([]));
    dispatch(action.saveCartSelectionsOptionalTiltrotator(undefined));
    dispatch(action.saveCartSelectionsOptionalToolsProductItems([]));
    dispatch(action.saveOptionalToolsIsMachineFixingsSelected(undefined));
    dispatch(action.saveCartSelectionsOptionalMachineFixing(undefined));
    dispatch(action.saveOptionalMachineFixingType(undefined));
    dispatch(action.saveCartSelectionsOptionalGrappleModule(undefined));
    dispatch(action.saveCartSelectionsOptionalNoGrappleModuleSelected(false));
  };

  const clearStateForOptionalTiltrotatorAccordian = () => {
    dispatch(action.saveCartSelectionsOptionalTiltrotator(undefined));
    dispatch(action.saveCartSelectionsOptionalGrappleModule(undefined));
    dispatch(action.saveCartSelectionsOptionalNoGrappleModuleSelected(false));
  };

  const clearStateForOptionalTiltrotator = () => {
    dispatch(action.saveCartSelectionsOptionalGrappleModule(undefined));
    dispatch(action.saveCartSelectionsOptionalNoGrappleModuleSelected(false));
  };

  const clearStateForOptionalMachineFixingsAccordian = () => {
    dispatch(action.saveOptionalMachineFixingType(undefined));
    dispatch(action.saveCartSelectionsOptionalMachineFixing(undefined));
  };

  const clearStateForOptionalToolsAccordian = () => {
    dispatch(action.saveOptionalToolsProductTypes([]));
    dispatch(action.saveCartSelectionsOptionalToolsProductItems([]));
  };

  return {
    clearStateAllProducts,
    clearStateForOptionalTools,
    clearStateForProductCategory,
    clearStateForProductCategoryTiltrotator,
    clearStateForProductMachineFixingType,
    clearStateForOptionalMachineFixingsAccordian,
    clearStateForOptionalTiltrotator,
    clearStateForOptionalTiltrotatorAccordian,
    clearStateForOptionalToolsAccordian,
  };
};
